module.exports = __webpack_public_path__ + "c2f2519df52701141b53dc3ee76534f3.svg";